import { useQueryClient } from '@tanstack/react-query'
import { useMemo } from 'react'
import { showSuccessMessage } from '../../../utils/message'

const useUpdateQueryItem = () => {
  const queryClient = useQueryClient()

  const updateQueryItem = useMemo(
    () => (options: { queryKey: string[] | readonly unknown[] }[]) => {
      options.forEach(o => queryClient.invalidateQueries({ queryKey: o.queryKey }))
      showSuccessMessage()
    },
    [queryClient]
  )

  return updateQueryItem
}

export default useUpdateQueryItem
